<template>
  <b-modal
    id="modal-pricing-komchat"
    ref="modal-pricing-komchat"
    hide-footer
    hide-header
    centered
    dialog-class="custom-modal"
    @hidden="$emit('resetWA')"
  >
    <div class="lg:py-[10px] grid justify-center">
      <div class="flex items-center gap-1 justify-center">
        <span
          class="text-[20px] text-center font-bold text-black"
        >Pilih Paket Komchat yang Tepat untuk Bisnis Anda  </span><b-img
          width="40"
          class=""
          src="https://storage.googleapis.com/komerce/assets/logo/logo-only/Logo-komchat.svg"
          alt=""
        />
      </div>
      <div class="text-center text-[16px]">
        Optimalkan komunikasi dan tingkatkan efisiensi bisnis Anda dengan fitur terbaik dari Komchat.
      </div>
      <div class="grid gap-5 mt-3 w-full justify-center lg:grid-cols-3">
        <div
          v-for="(item, index) in cardPricing"
          :key="index"
        >
          <div
            :class="item.name !== 'Pro' ? 'bg-white' : 'bg-gradient-to-b from-[#FF4B26] to-[#AD1212]' "
            class="rounded-2xl relative border border-[#C2C2C2] p-[25px]"
          >
            <div
              v-show="item.name === 'Pro'"
              class="absolute right-[-3px] top-0"
            >
              <span class="py-[4px] h-[40px] text-white w-fit  flex items-center gap-1 pl-[12px] pr-[9px] bg-[#F0F0F06B] rounded-full !rounded-br-[0px] !rounded-tr-[0px]">Meta Official <img
                src="https://storage.googleapis.com/komerce/assets/illustration/check-blue.svg"
                alt=""
                srcset=""
              > </span>
            </div>
            <div
              :class="item.name === 'Pro' ? 'bg-white' : 'bg-gradient-to-b from-[#FE4A26] to-[#BA1B15]'"
              class=" w-[140px] text-[22px] flex justify-center items-center h-[50px]  rounded-lg p-[8px]"
            >
              <span
                :class="item.name !== 'Pro' ? 'text-white': 'text-black'"
                class=" text-[20px] font-semibold"
              >{{ item.name }}</span>
            </div>
            <div class="flex h-[80px] gap-2 mt-2 ">
              <div
                :class="item.name === 'Pro' ? 'text-white': 'text-black'"
                class="text-sm"
                v-html="item.subTitle"
              />
            </div>
            <div class="">
              <div
                :class="item.name === 'Pro' ? 'text-white': 'text-black'"
                class="flex gap-2"
              >
                <span class="font-bold flex items-start  text-[24px]">Rp  </span><span class="font-bold  text-[42px]">{{ item.price }} </span><span class="flex items-center">/Bulan</span>
              </div>
            </div>
            <hr>
            <div class="h-[350px] mt-1">
              <div
                v-for="(point, indexPoint) in item.point"
                :key="indexPoint"
              >
                <div
                  class="flex mb-2 leading-5 items-center gap-2"
                >
                  <b-icon
                    v-if="point.active === true"
                    :class="item.name === 'Pro' ? 'text-white text-primary rounded-circle bg-white': 'text-primary'"
                    class="y text-[20px]"
                    :icon="item.name !== 'Pro' ? 'check-circle-fill': 'check'"
                  />
                  <b-icon
                    v-if="point.active === false"
                    class="text-[20px] rounded-circle bg-[#FED6CE] text-primary"
                    icon="x"
                  />
                  <div
                    :class="item.name === 'Pro' ? 'text-white': 'text-black'"
                    class="text-sm "
                    v-html="point.text"
                  />

                </div>
              </div>
            </div>
            <hr>
            <b-button
              class="mt-2"
              variant="light"
              block
              :disabled="!disabledButton(item.levelPackage)"
              @click="submit(item.idPackage)"
            >
              Aktifkan
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <subscribeConfirmModal
      :package-name="packageName"
      :package-price="subscriptionFee"
      :cta="cta"
      :is-loading="loadingSubcription"
      @confirm-subscribe="handleSubscribe"
    />
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { pointModalPricing, cardPricing } from '../static'
import { apiSubs } from '../service/api.whatsapp.services'
import subscribeConfirmModal from './subscribe-confirm-modal.vue'

export default {
  components: {
    subscribeConfirmModal,
  },
  props: {
    packageLevel: {
      type: Number,
      default: 0,
    },
    isUpgrade: {
      type: Boolean,
      default: false,
    },
    reActivate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pointModalPricing,
      isKomchat: this.$store.state.dashboard.profile.is_komchat === 1,
      isKomchatOnly: this.$store.state.dashboard.profile.is_komship === 0 && this.$store.state.dashboard.profile.is_komchat === 1,
      badge: this.$store.state.whatsapp.check_wa.is_user_type,
      loadingSubcription: false,
      cardPricing,
      packageName: '',
      cta: '',
      idPackage: 0,
      subscriptionFee: 0,
    }
  },
  computed: {
    ...mapState('komchat', {
      listPlan: state => state.subsPlanList,
    }),
  },
  methods: {
    submit(id) {
      this.idPackage = id
      if (this.isUpgrade === true || this.reActivate === true) {
        this.checkSaldo(id)
      } else {
        this.$emit('submit', id)
      }
    },
    getKomchatPlan(id) {
      if (id < 5) {
        return 'Komchat Starter'
      } if (id < 8) {
        return 'Komchat Basic'
      }
      return 'Komchat Pro'
    },
    checkSaldo(id) {
      const selectedPlan = this.listPlan.find(item => item.id === id)
      if (!selectedPlan) {
        console.error('Plan not found')
        return
      }
      this.subscriptionFee = selectedPlan.nominal
      const kompayBalance = this.$store.state.saldo.saldo
      this.packageName = this.getKomchatPlan(id)
      // this.$bvModal.hide('modal-pricing-komchat')

      if (this.badge === 'Regular' || (this.badge !== 'Regular' && id >= 5)) {
        this.cta = kompayBalance < this.subscriptionFee ? 'Top Up Saldo' : 'Bayar Sekarang'
        this.$bvModal.show('confirm-subscribe-modal')
      } else {
        this.$swal({
          title: 'Konfirmasi Berlangganan',
          html: `<span>sebagai <b>${this.badge}</b> kamu bisa menggunakan <b>Komchat Starter secara gratis</b> Aktifkan sekarang!</span>`,
          imageUrl: 'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
          confirmButtonText: 'Aktifkan',
          width: 500,
          confirmButtonClass: 'btn btn-primary',
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          cancelButtonText: 'Batal',
          cancelButtonColor: '#FFFFFF',
          cancelButtonClass: 'btn btn-outline-primary text-primary',
        }).then(response => {
          if (response.isConfirmed) {
            this.subscribe(id)
          } else {
            this.$bvModal.show('modal-pricing-komchat')
          }
        })
      }
    },
    async handleSubscribe(qualified) {
      if (!qualified) {
        this.$router.push('/keuangan/saldo')
      } else {
        await this.subscribe(this.idPackage)
      }
      this.$bvModal.hide('modal-choose-wa')
    },
    async subscribe(id) {
      console.log(id)
      try {
        this.loadingSubcription = true
        await apiSubs(id)
        this.$toast_success({ message: 'Berhasil melakukan pembayaran' })
        this.$bvModal.hide('modal-pricing-komchat')
        await this.$store.dispatch('whatsapp/getUpdateDashboardWa')
        await this.$store.dispatch('saldo/getBalanceSummary')
        this.loadingSubcription = false
      } catch (error) {
        this.loadingSubcription = false
        this.$toast_error({ message: 'Gagal melakukan pembayaran' })
        this.$bvModal.hide('modal-pricing-komchat')
      }
    },
    disabledButton(id) {
      const isGeneralAccess = !this.isKomchatOnly || (this.isKomchatOnly && !this.isUpgrade)
      const enablementRules = {
        1: () => this.isKomchatOnly || this.isUpgrade,
        5: () => isGeneralAccess || (this.isUpgrade && this.packageLevel < 2),
        9: () => isGeneralAccess || (this.isUpgrade && this.packageLevel < 3),
      }
      const rule = enablementRules[id] || (() => false)
      return !rule()
    },

  },
}

</script>

<style >
.custom-modal {
  /* Default for mobile */
  max-width: 100%;
  border-radius: 1rem;

  /* Tablet */
  @media (min-width: 768px) {
    max-width: 700px;
  }

  /* Desktop */
  @media (min-width: 992px) {
    max-width: 1150px;
  }
}

</style>
